import { forwardRef, type SVGProps } from 'react';

export const Hamburger = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg
    ref={ref}
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 12h18M3 6h18M3 18h18" />
  </svg>
));

export const ShortHamburger = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg viewBox="0 0 21 19" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M19.748 15.333c.374 0 .525.042.673.121a.823.823 0 01.342.343c.079.147.121.299.121.673v.444c0 .374-.042.526-.12.673a.823.823 0 01-.343.343c-.148.079-.3.12-.673.12H2.093c-.374 0-.525-.041-.673-.12a.823.823 0 01-.342-.343c-.08-.147-.121-.299-.121-.673v-.444c0-.374.042-.526.12-.673a.823.823 0 01.343-.343c.148-.079.299-.12.673-.12h17.655zm0-7.246c.374 0 .525.042.673.12a.823.823 0 01.342.343c.079.148.121.3.121.673v.445c0 .374-.042.525-.12.673a.823.823 0 01-.343.342c-.148.08-.3.121-.673.121H5.716c-.374 0-.525-.042-.673-.12a.823.823 0 01-.342-.343c-.08-.148-.121-.299-.121-.673v-.445c0-.374.042-.525.12-.673a.823.823 0 01.343-.342c.148-.079.3-.121.673-.121h14.032zm0-7.246c.374 0 .525.042.673.12a.823.823 0 01.342.343c.079.148.121.299.121.673v.445c0 .374-.042.525-.12.673a.823.823 0 01-.343.342c-.148.079-.3.121-.673.121H2.093c-.374 0-.525-.042-.673-.121a.823.823 0 01-.342-.342c-.08-.148-.121-.3-.121-.673v-.445c0-.374.042-.525.12-.673A.823.823 0 011.42.962c.148-.08.299-.121.673-.121h17.655z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
));
